import React from 'react';
import { SINAV_DERSLERI, DERSLER, kazanimSozleri, sikHarfleri } from '../../lib/dersler.js';
import { DersPills } from '../ui/Pills';
import { MUFREDATLAR, ZORLUK_PROFILLERI } from './sabitler';
import { secimSinifi, SECILI_ISARET, konuTestDersleri, gunStr, testHarfOzeti } from './yardimcilar';
import SabitListe, { useSoruDetay } from './SabitListe';
import KazanimListesi from './KazanimListesi';
import SoruListesi from './SoruListesi';
import SoruEkleci from './SoruEkleci';
import HaftaKapsami from './HaftaKapsami';
import NumaraListesi from './NumaraListesi';
import DengeliSecim from './DengeliSecim';

// ============================================================
// C — KONU TESTİ / GENEL DENEME içerik bölümü (Faz C, 2026-09-03).
//   Kaynak: Filtre (havuzdan) | Seçili (elle)
//   Filtre: Sınav [TYT|AYT] → Ders(ler) (pill, ≥1 ZORUNLU, çoklu seçim) → her ders
//           için Kazanım(lar) + adet → Zorluk profili (ortak) → Müfredat (ortak)
//   Seçili: liste + Soru Ekle
// ÇOK DERSLİ (2026-09-03, kullanıcı: "birden fazla ders ve konu seçilebilmeli"):
//   `konuTest.dersler = [{ders, kazanimlar, adet}]` (seçim sırası). Tek ders →
//   backend tek dersli kanal (filtre.ders + kazanimDagilimi); 2+ ders →
//   filtre.dersPlani + ÖSYM çok-testli çıktı (kapak + test bölümlü cevap anahtarı).
// Sade akış: seçim butonları tek tip belirgin (`secimSinifi`, ✓ öneki); özet metni yok.
// ============================================================
export default function KonuTestiPaneli({
  apiUrl, kaynakModu, setKaynakModu, konuTest, setKonuTest, mufredat, setMufredat,
  dersOzeti, maarifOzeti, dersIdleri = {}, yayineviId = null, onYayineviSec = null, numaraDolgu = null,
  aktifTaslak = null, taslakNot = null, onTaslakKaydet = () => {}, onTaslakAc = () => {},
  seciliSorular, seciliYukleniyor, eklePaneliAcik, setEklePaneliAcik,
  soruyuSil, soruyuTasi, dragHandlers, seciliKaristir, seciliTemizle, soruEkle, sorulariEkle,
}) {
  const seciliCount = seciliSorular.length;
  const aileler = SINAV_DERSLERI[konuTest.sinav] || SINAV_DERSLERI.TYT;
  // LGS (2026-10-20): tek sınav, hepsi Maarif 8. sınıf — müfredat/sınıf/hafta süzgeci ve (TYT/AYT
  // ailelerine kurulu) dengeli seçim gösterilmez.
  const lgs = konuTest.sinav === 'LGS';
  const dersler = konuTestDersleri(konuTest);
  const set = (parca) => setKonuTest(o => ({ ...o, ...parca }));
  const derslerYaz = (yeni) => set({ dersler: yeni, ders: yeni[0] ? yeni[0].ders : '' });
  // Pill tıklaması: seçiliyse çıkar, değilse ekle (kazanım listesi boş, adet varsayılan).
  const dersToggle = (key) => {
    const varMi = dersler.some(d => d.ders === key);
    if (varMi) derslerYaz(dersler.filter(d => d.ders !== key));
    else derslerYaz([...dersler, { ders: key, kazanimlar: [], adet: konuTest.adet || 20 }]);
  };
  const dersGuncelle = (key, parca) => derslerYaz(dersler.map(d => (d.ders === key ? { ...d, ...parca } : d)));
  const sinavSec = (s) => {
    if (s === konuTest.sinav) return;
    // Sınav değişince ders listesi sıfırlanır (haritalar dersler arası çakışır).
    set({ sinav: s, ders: '', dersler: [], kazanimlar: [] });
  };
  const dersToplam = (d) => (Array.isArray(d.sabitIds) && d.sabitIds.length > 0
    ? d.sabitIds.length
    : (d.kazanimlar.length > 0
      ? d.kazanimlar.reduce((a, k) => a + (Number(k.adet) || 0), 0)
      : (Number(d.adet) || 0)));
  const toplam = dersler.reduce((a, d) => a + dersToplam(d), 0);
  const Etiket = ({ children, title }) => (
    <span className="text-[10px] text-gray-500 font-bold uppercase" title={title}>{children}</span>
  );
  const dersAd = (key) => (DERSLER.find(x => x.value === key)?.label || key).replace(/^(TYT|AYT|LGS)\s+/i, '');
  // Sabit listeler (numara listesi / "Soruları sabitle"): satır ayrıntıları + listedeki bütün numaralar
  // (Değiştir adayları ve ekleme bunları dışlar).
  const sabitDersler = dersler.filter(d => Array.isArray(d.sabitIds) && d.sabitIds.length > 0);
  const sabitDetay = useSoruDetay(apiUrl, sabitDersler.flatMap(d => d.sabitIds));
  const tumSabitNolar = sabitDersler.flatMap(d => d.sabitIds.map((id, i) => (sabitDetay[id] && sabitDetay[id].public_no != null
    ? Number(sabitDetay[id].public_no) : (Array.isArray(d.sabitNolar) ? d.sabitNolar[i] : null)))).filter(n => n != null);
  const testOzet = sabitDersler.length > 0 ? testHarfOzeti(konuTest.sinav, dersler, sabitDetay) : [];
  const dersIkon = (key) => aileler.find(a => a.key === key)?.ikon || '';
  const soz = kazanimSozleri(mufredat);

  return (
    <div className="mt-2 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <Etiket>Kaynak</Etiket>
        <button type="button" onClick={() => setKaynakModu('filtre')} aria-pressed={kaynakModu === 'filtre'}
          title={`Ders + ${soz.ad} + zorluk filtresine uyan onaylı sorular havuzdan çekilir`}
          className={secimSinifi(kaynakModu === 'filtre')}>
          {kaynakModu === 'filtre' ? SECILI_ISARET : ''}Filtre
        </button>
        <button type="button" onClick={() => setKaynakModu('secili')} aria-pressed={kaynakModu === 'secili'}
          title="Belirli soruları elle ekleyip bas"
          className={secimSinifi(kaynakModu === 'secili')}>
          {kaynakModu === 'secili' ? SECILI_ISARET : ''}Seçili{seciliCount > 0 ? ` (${seciliCount})` : ''}
        </button>
        <span className="text-[11px] text-gray-500">
          {kaynakModu === 'filtre'
            ? 'Önizle: ön kontrol listeyi seçer, önizleme ve PDF aynı soruları basar.'
            : 'Elle seçilen sorular verilen sırayla basılır.'}
        </span>
      </div>

      {kaynakModu === 'secili' ? (
        <div>
          <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
            <h3 className="text-sm font-bold text-gray-700 flex items-center gap-1.5">
              <span className="w-1 h-4 bg-orange-500 rounded" />
              Sorular ({seciliCount})
            </h3>
            <div className="flex gap-1">
              <button onClick={seciliKaristir} disabled={seciliCount < 2}
                title="Karıştır (Fisher-Yates)"
                className="text-xs px-2 py-1 rounded bg-purple-50 text-purple-700 hover:bg-purple-100 font-semibold disabled:opacity-40">
                🎲 Karıştır
              </button>
              <button onClick={seciliTemizle} disabled={seciliCount === 0}
                className="text-xs px-2 py-1 rounded bg-gray-100 text-gray-600 hover:bg-gray-200 disabled:opacity-40">
                Temizle
              </button>
              <button onClick={() => setEklePaneliAcik(!eklePaneliAcik)}
                className="text-xs px-3 py-1 rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 font-semibold">
                {eklePaneliAcik ? '× Kapat' : '+ Soru Ekle'}
              </button>
            </div>
          </div>
          {seciliYukleniyor ? (
            <div className="text-center py-8 text-gray-400 text-sm">⏳ Sorular yükleniyor...</div>
          ) : seciliCount === 0 ? (
            <div className="text-center py-6 text-gray-400 text-sm italic px-4">
              Henüz soru seçilmedi. <br />
              <button onClick={() => setEklePaneliAcik(true)} className="text-blue-600 underline">+ Soru Ekle</button>
            </div>
          ) : (
            <SoruListesi sorular={seciliSorular} onSil={soruyuSil} onTasi={soruyuTasi} dragHandlers={dragHandlers} />
          )}
          {eklePaneliAcik && (
            <SoruEkleci apiUrl={apiUrl} onEkle={soruEkle} onTopluEkle={sorulariEkle} mevcutIds={seciliSorular.map(s => s.id)} />
          )}
        </div>
      ) : (
        <div className="space-y-3">
          {/* DENEME TASLAĞI (Faz 3, 2026-10-09): sunucuda adıyla kayıt — her cihazdan açılır. */}
          <div data-taslak-cubugu className="flex flex-wrap items-center gap-2 text-[11px]">
            <span className="text-[10px] text-gray-500 font-bold uppercase">Taslak</span>
            {aktifTaslak
              ? <span data-aktif-taslak className="font-semibold text-gray-800">📁 {aktifTaslak.ad} <span className="font-normal text-gray-500">· sürüm {aktifTaslak.surum}</span></span>
              : <span className="text-gray-500">kaydedilmedi</span>}
            <button type="button" data-taslak-kaydet onClick={() => onTaslakKaydet(false)}
              className="px-2 py-0.5 rounded bg-emerald-600 text-white font-semibold hover:bg-emerald-700">
              💾 {aktifTaslak ? 'Kaydet' : 'Taslak olarak kaydet'}
            </button>
            {aktifTaslak && (
              <button type="button" data-taslak-farkli onClick={() => onTaslakKaydet(true)}
                className="px-2 py-0.5 rounded bg-white border border-emerald-300 text-emerald-800">Farklı kaydet</button>
            )}
            <button type="button" data-taslak-ac onClick={onTaslakAc}
              className="px-2 py-0.5 rounded bg-white border border-gray-300 text-gray-700">📂 Taslak aç</button>
            {taslakNot && <span data-taslak-not className={taslakNot.tip === 'hata' ? 'text-red-700 font-semibold' : 'text-emerald-800'}>{taslakNot.metin}</span>}
          </div>
          {/* NUMARA LİSTESİ (2026-10-09): ders(ler) + sabit soru listeleri tek yapıştırmayla kurulur. */}
          <NumaraListesi apiUrl={apiUrl} yayineviId={yayineviId} onYayineviSec={onYayineviSec} dolgu={numaraDolgu}
            onUygula={(plan) => set({ sinav: plan.sinav, dersler: plan.dersler, ders: plan.dersler[0].ders, kazanimlar: [], hafta: '' })} />
          {/* SINAV + DERS(LER) */}
          <div className="flex flex-wrap items-center gap-2">
            <Etiket>Sınav</Etiket>
            {(lgs ? ['LGS'] : ['TYT', 'AYT']).map(s => (
              <button key={s} type="button" onClick={() => sinavSec(s)} aria-pressed={konuTest.sinav === s}
                className={secimSinifi(konuTest.sinav === s)}>
                {konuTest.sinav === s ? SECILI_ISARET : ''}{s}
              </button>
            ))}
            <Etiket title={`Birden fazla ders seçilebilir: her ders kendi ${soz.ad} ve soru sayısıyla, ÖSYM test bloklarında basılır`}>Ders(ler)</Etiket>
            {dersler.length === 0
              ? <span className="text-[11px] text-red-600 font-semibold">seçilmedi — en az bir ders zorunlu</span>
              : <span className="text-[11px] text-gray-600">{dersler.length} ders · <strong>{toplam}</strong> soru
                {dersler.length > 1 && <span className="ml-1 text-indigo-700" title="Birden fazla ders: ÖSYM çok-testli kitapçık (kapak + test başlıkları + test bölümlü cevap anahtarı)">· genel deneme (ÖSYM çok-testli)</span>}</span>}
          </div>
          <DersPills aileler={aileler} aktifKeys={dersler.map(d => d.ders)} onSec={dersToggle} ozet={dersOzeti} maarif={maarifOzeti} seciliIsaret />

          {/* DENEME DENGESİ (Faz 2): sabit derslerin ÖSYM testi başına soru + harf bandı (2026-10-10). */}
          {testOzet.length > 0 && (
            <div data-deneme-denge className="flex flex-wrap gap-x-4 gap-y-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5 text-[10px] text-gray-700">
              <span className="font-bold text-gray-800">Deneme dengesi</span>
              {testOzet.map(t => (
                <span key={t.ad} data-test-ozet={t.ad} className={t.asim.length ? 'text-red-700 font-semibold' : ''}>
                  {t.ad}: {t.n} soru · {sikHarfleri(konuTest.sinav).map(h => `${h}${t.harf[h] || 0}`).join(' ')}
                  {t.asim.length > 0 && ` ⚠ ${t.asim.join(', ')} bant dışı (${t.alt}-${t.tavan})`}
                </span>
              ))}
            </div>
          )}

          {dersler.map((d, i) => (
            <div key={d.ders} className="rounded-lg border border-indigo-100 bg-indigo-50/40 px-3 py-2" data-ders-blok={d.ders}>
              <div className="flex flex-wrap items-center justify-between gap-2 mb-1"
                title={`${soz.Ad} seçmezseniz dersin tüm ${soz.adlarindan} çekilir. Birden fazla ${soz.ad} seçip her birine adet verebilirsiniz; üst ${soz.ad} seçildiğinde alt ${soz.adlari} da kapsar.`}>
                <div className="text-[11px] font-bold text-indigo-900 flex items-center gap-1.5">
                  <span>{dersIkon(d.ders)}</span>
                  <span>{i + 1}. {dersAd(d.ders)}</span>
                  <span className="font-normal text-indigo-700">· {dersToplam(d)} soru</span>
                </div>
                <div className="flex items-center gap-1">
                  {dersler.length > 1 && i > 0 && (
                    <button type="button" title="Yukarı taşı (kitapçıkta blok içi sıra)" onClick={() => {
                      const y = [...dersler]; [y[i - 1], y[i]] = [y[i], y[i - 1]]; derslerYaz(y);
                    }} className="text-[10px] px-1.5 py-0.5 rounded bg-white border border-indigo-100 hover:bg-indigo-100">↑</button>
                  )}
                  <button type="button" title="Bu dersi kaldır" onClick={() => dersToggle(d.ders)}
                    className="text-[10px] px-1.5 py-0.5 rounded bg-white border border-indigo-100 text-red-600 hover:bg-red-50">✕ kaldır</button>
                </div>
              </div>
              {Array.isArray(d.sabitIds) && d.sabitIds.length > 0 ? (
                <div data-ders-sabit={d.ders} className="flex flex-wrap items-center gap-2 text-[11px]">
                  <span className="px-2 py-1 rounded bg-amber-100 text-amber-900 font-semibold">
                    🔒 {d.sabitIds.length} soru sabit — bu dersin soruları her basımda aynı
                  </span>
                  <button type="button" onClick={() => dersGuncelle(d.ders, { sabitIds: undefined, sabitNolar: undefined })}
                    className="px-2 py-0.5 rounded bg-white border border-amber-300 hover:bg-amber-50">çöz</button>
                  <SabitListe apiUrl={apiUrl} d={d} detay={sabitDetay} tumNolar={tumSabitNolar} yayineviId={yayineviId}
                    puanMin={konuTest.puanMin} puanMax={konuTest.puanMax}
                    onDegis={(yeni) => (yeni.sabitIds.length === 0
                      ? derslerYaz(dersler.filter((x) => x.ders !== d.ders))
                      : dersGuncelle(d.ders, { sabitIds: yeni.sabitIds, sabitNolar: yeni.sabitNolar, adet: yeni.adet }))} />
                </div>
              ) : (
                <>
                  <KazanimListesi apiUrl={apiUrl} ders={d.ders} mufredat={mufredat}
                    kazanimlar={d.kazanimlar} adet={d.adet}
                    onDegis={(kz) => dersGuncelle(d.ders, { kazanimlar: kz })}
                    onAdetDegis={(n) => dersGuncelle(d.ders, { adet: n })} />
                  {dersler.length > 1 && Array.isArray(dersIdleri[d.ders]) && dersIdleri[d.ders].length === dersToplam(d) && (
                    <button type="button" data-ders-sabitle={d.ders}
                      onClick={() => dersGuncelle(d.ders, { sabitIds: [...dersIdleri[d.ders]] })}
                      title="Son önizlemede bu derse gelen soruları sabitler: başka bir denemede (ör. 11 Sayısal → 11 Eşit Ağırlık) bu ders AYNI sorularla basılır. Şablona kaydedilir."
                      className="mt-1 text-[11px] px-2 py-0.5 rounded bg-white border border-amber-300 text-amber-900 font-semibold hover:bg-amber-50">
                      🔒 Soruları sabitle
                    </button>
                  )}
                </>
              )}
            </div>
          ))}

          {dersler.length > 0 && (
            <>
              {/* ZORLUK PROFİLİ (tüm dersler için ortak) */}
              <div className="flex flex-wrap items-center gap-1.5">
                <Etiket title="Öğretmen puanına göre kolay (2-4) / orta (5-6) / zor (7-10) kovaları — tüm derslere aynı profil, ders adetlerine oranla bölünür">Zorluk</Etiket>
                {ZORLUK_PROFILLERI.map(p => (
                  <button key={p.id} type="button" onClick={() => set({ zorlukProfil: p.id })} title={p.t}
                    aria-pressed={konuTest.zorlukProfil === p.id}
                    className={secimSinifi(konuTest.zorlukProfil === p.id)}>
                    {konuTest.zorlukProfil === p.id ? SECILI_ISARET : ''}{p.l}
                  </button>
                ))}
              </div>

              {/* MÜFREDAT (havuz, ortak) */}
              {!lgs && <div className="flex flex-wrap items-center gap-1.5">
                <Etiket title="Müfredat: 2018 (MEB) veya Maarif (2028+) sorularını ayrı basın">Müfredat</Etiket>
                {MUFREDATLAR.map(m => {
                  const aktif = (mufredat || '') === m.v;
                  let sayi = null;
                  if (dersOzeti && dersler.length === 1 && dersOzeti[dersler[0].ders] != null) {
                    const hepsi = dersOzeti[dersler[0].ders] || 0;
                    const maarif = (maarifOzeti && maarifOzeti[dersler[0].ders]) || 0;
                    sayi = m.v === '' ? hepsi : m.v === 'Maarif_2024' ? maarif : Math.max(0, hepsi - maarif);
                  }
                  return (
                    <button key={m.v || 'hepsi'} type="button" aria-pressed={aktif}
                      onClick={() => {
                        setMufredat(m.v); derslerYaz(dersler.map(d => ({ ...d, kazanimlar: [] })));
                        if (m.v !== 'Maarif_2024') set({ hafta: '' }); // yıllık plan yalnız Maarif
                      }}
                      className={secimSinifi(aktif)}>
                      {aktif ? SECILI_ISARET : ''}{m.l}{sayi != null && <span className="ml-1 opacity-70">{sayi}</span>}
                    </button>
                  );
                })}
                <span className="text-[10px] text-gray-500">
                  {dersler.map(d => dersAd(d.ders)).join(' + ')} · onaylı havuz
                </span>
              </div>}

              {/* OKUL DENEMESİ (2026-10-08): sınıf + zorluk puan aralığı + bağlam + harf dengesi. */}
              <div className="flex flex-wrap items-center gap-1.5" data-okul-suzgec>
                {!lgs && <Etiket title="Yalnız seçilen sınıfın öğrenme çıktılarına ait sorular (Türkçe 10. sınıfta 9 ve 10 birlikte: paragraf ve anlam her sınıfa uyar)">Sınıf</Etiket>}
                {!lgs && ['', 9, 10, 11, 12].map(n => {
                  const aktif = String(konuTest.sinif || '') === String(n);
                  return (
                    <button key={n || 'tumu'} type="button" aria-pressed={aktif} data-sinif={n || 'tumu'}
                      onClick={() => set(n && n !== 12 ? { sinif: n } : { sinif: n, hafta: '' })} className={secimSinifi(aktif)}>
                      {aktif ? SECILI_ISARET : ''}{n ? `${n}. sınıf` : 'Tümü'}
                    </button>
                  );
                })}
                <Etiket title="Öğretmen zorluk puanı aralığı (2-10); boş = sınır yok. Puansız sorular aralık verilince girmez.">Puan</Etiket>
                <input type="number" min={2} max={10} data-puan="min" value={konuTest.puanMin ?? ''}
                  onChange={e => set({ puanMin: e.target.value })} placeholder="en az"
                  className="px-1.5 py-1 rounded border border-gray-300 text-[11px] w-16" />
                <span className="text-[10px] text-gray-400">–</span>
                <input type="number" min={2} max={10} data-puan="max" value={konuTest.puanMax ?? ''}
                  onChange={e => set({ puanMax: e.target.value })} placeholder="en çok"
                  className="px-1.5 py-1 rounded border border-gray-300 text-[11px] w-16" />
                <button type="button" aria-pressed={!!konuTest.baglamHaric} data-baglam-haric
                  onClick={() => set({ baglamHaric: !konuTest.baglamHaric })}
                  title="Bağlam temelli çift soruları seçime alma — yayınevine teslimde kardeş soru eklenip ders adedi bozulmaz"
                  className={secimSinifi(!!konuTest.baglamHaric)}>
                  {konuTest.baglamHaric ? SECILI_ISARET : ''}Bağlam çiftlerini dışla
                </button>
                <button type="button" aria-pressed={!!konuTest.harfDengesi} data-harf-dengesi
                  onClick={() => set({ harfDengesi: !konuTest.harfDengesi })}
                  title={`Cevap anahtarı tek harfte toplanmasın: her testte ve ders bloğunda bir harf en çok %30 ve her harf ${lgs ? 'n/4' : 'n/5'} bandında; fazla harfli soru aynı öğrenme çıktısı ve zorluktan başka soruyla değiştirilir`}
                  className={secimSinifi(!!konuTest.harfDengesi)}>
                  {konuTest.harfDengesi ? SECILI_ISARET : ''}Cevap harfi dengesi
                </button>
              </div>

              {/* HAFTA SÜZGECİ (TYMM Öğrenme Kanıtı, 2026-10-09): 2026 DÖP yıllık planında seçilen
                  haftaya kadar TAMAMLANAN öğrenme çıktılarından soru (sınıf + Maarif zorunlu). */}
              {[9, 10, 11].includes(Number(konuTest.sinif)) && (
                <div className="space-y-1.5">
                  <div className="flex flex-wrap items-center gap-1.5">
                    <Etiket title="Yıllık plana göre bu haftaya kadar işlenmiş öğrenme çıktılarından soru gelir; yarıda olan çıktı sorulmaz. Maarif müfredatı gerekir.">Hafta</Etiket>
                    <select data-hafta value={konuTest.hafta || ''}
                      onChange={(e) => {
                        const h = e.target.value ? Number(e.target.value) : '';
                        set({ hafta: h });
                        if (h && mufredat !== 'Maarif_2024') {
                          setMufredat('Maarif_2024');
                          derslerYaz(dersler.map(d => ({ ...d, kazanimlar: [] })));
                        }
                      }}
                      className="px-1.5 py-1 rounded border border-gray-300 text-[11px]">
                      <option value="">— tüm yıl</option>
                      {Array.from({ length: 36 }, (_, i) => i + 1).map(h => (
                        <option key={h} value={h}>{h}. hafta{h === 18 ? ' (1. dönem sonu)' : ''}</option>
                      ))}
                    </select>
                    {konuTest.hafta && mufredat === 'Maarif_2024' && (
                      <span className="text-[10px] text-gray-500">Maarif müfredatı · seçili öğrenme çıktısı varsa kapsam dışı olanı sunucu reddeder</span>
                    )}
                    {konuTest.hafta && Number(konuTest.sinif) === 11 && dersler.some(d => /cografya$/.test(d.ders)) && (
                      <>
                        <Etiket title="11. sınıf Coğrafya DÖP'ü haftada 2 ve 4 saatlik iki plan verir">Coğrafya</Etiket>
                        {[2, 4].map(s => (
                          <button key={s} type="button" data-cografya-saat={s} aria-pressed={Number(konuTest.cografyaSaat || 2) === s}
                            onClick={() => set({ cografyaSaat: s })} className={secimSinifi(Number(konuTest.cografyaSaat || 2) === s)}>
                            {Number(konuTest.cografyaSaat || 2) === s ? SECILI_ISARET : ''}haftada {s} saat
                          </button>
                        ))}
                      </>
                    )}
                  </div>
                  {konuTest.hafta && (
                    <HaftaKapsami apiUrl={apiUrl} sinif={Number(konuTest.sinif)} hafta={Number(konuTest.hafta)}
                      dersler={dersler.map(d => d.ders)} cografyaSaat={Number(konuTest.cografyaSaat || 2)} />
                  )}
                </div>
              )}

              {/* DENGELİ SEÇİM (Faz 3): sınıf/puan/müfredat yukarıdaki seçimlerden. */}
              {!lgs && <DengeliSecim apiUrl={apiUrl} konuTest={konuTest} mufredat={mufredat} dersler={dersler}
                tumSabitNolar={tumSabitNolar} yayineviId={yayineviId} onUygula={(yeni) => derslerYaz(yeni)} />}

              {/* ÜRETİM TARİHİ ARALIĞI (2026-09-21, öğretmen isteği: filtre kanalına da).
                  Havuzu daraltır — kota bu daraltılmış havuzdan doldurulur; yetmezse
                  ön kontrol eksiği raporlar. Boş = tüm havuz (eski davranış). */}
              <div className="flex flex-wrap items-center gap-1.5">
                <Etiket title="Sorunun üretildiği gün — havuzu bu aralıkla sınırlar (boş bırakılırsa tüm havuz)">Tarih</Etiket>
                <input type="date" data-konu-tarih="min" value={konuTest.tarihMin || ''} max={konuTest.tarihMax || undefined}
                  onChange={e => set({ tarihMin: e.target.value })} title="Bu tarihten itibaren üretilenler"
                  className="px-1.5 py-1 rounded border border-gray-300 text-[11px]" />
                <span className="text-[10px] text-gray-400">→</span>
                <input type="date" data-konu-tarih="max" value={konuTest.tarihMax || ''} min={konuTest.tarihMin || undefined}
                  onChange={e => set({ tarihMax: e.target.value })} title="Bu tarihe kadar (gün dâhil)"
                  className="px-1.5 py-1 rounded border border-gray-300 text-[11px]" />
                {[{ l: 'Bugün', n: 0 }, { l: '7 gün', n: 6 }, { l: '30 gün', n: 29 }].map(h => (
                  <button key={h.l} type="button" onClick={() => set({ tarihMin: gunStr(h.n), tarihMax: gunStr(0) })}
                    className="text-[10px] px-2 py-0.5 rounded font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200">
                    {h.l}
                  </button>
                ))}
                {(konuTest.tarihMin || konuTest.tarihMax) ? (
                  <button type="button" onClick={() => set({ tarihMin: '', tarihMax: '' })}
                    className="text-[10px] px-2 py-0.5 rounded font-semibold bg-gray-100 text-gray-500 hover:bg-gray-200">
                    ✕ tarih
                  </button>
                ) : (
                  <span className="text-[10px] text-gray-500">boş = tüm havuz</span>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
